import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  accordion: {
    borderRadius: 10,
    '& .MuiAccordionSummary-root.Mui-focused': {
      background: 'white'
    },
    '&:before': {
      display: 'none'
    }
  },
  accordionSummary: {
    position: 'static'
  },
  accordionDetails: {
    paddingBottom: 20
  },
  expandBtn: {
    padding: '5px 10px'
  },
  expandBtnIcon: {
    fontSize: 16,
    transition: 'all 0.4s'
  },
  wlViewWrapper: {
    paddingBottom: 48
  },
  statusProgressContent: {
    padding: '4px 12px !important'
  },
  infoCard: {
    backgroundColor: 'white',
    borderRadius: 12
  },
  clientInfo: {
    margin: '0 0 20px 0'
  },
  carInfo: {
    marginLeft: 'auto'
  }
}))
